import { useMemo } from 'react';
import { EcoLabel } from '~/graphql/__generated__/graphql';
import { StyledEcoLabel } from '../styles/styled-eco-label';

export const EcoLabelElement = ({ ecoLabel }: { ecoLabel: EcoLabel | null | undefined }) => {
	const src = useMemo((): string | null | undefined => {
		if (!ecoLabel) {
			return null;
		}
		if (ecoLabel === 'ECO')
			return 'https://mediaservice.audi.com/media/b2c/v6-common/img-HEAD.zip/v6/eec/eco-label-small.svg';
		if (ecoLabel === 'ZERO')
			return 'https://mediaservice.audi.com/media/b2c/v6-common/img-HEAD.zip/v6/eec/cero-label-small.svg';
		if (ecoLabel === 'ECO_IT')
			return 'https://mediaservice.audi.com/media/b2c/v6-common/img-HEAD.zip/v6/eec/eco-it-label-small.svg';
	}, [ecoLabel]);

	return src ? <StyledEcoLabel alt="Eco Label" src={src} /> : null;
};
